// import { forwardRef } from "react";

// const LabelPrint58 = forwardRef(({ items = [] }, ref) => {
//     return (
//         <div
//             ref={ref}
//             style={{
//                 width: "380px",
//                 padding: "0",
//                 fontFamily: "Arial",
//             }}
//         >
//             {items.length === 0 && (
//                 <div style={{ padding: 20, textAlign: "center", fontSize: 14 }}>
//                     No Label Data Found
//                 </div>
//             )}

//             {items.map((item, index) => (
//                 <div
//                     key={index}
//                     style={{
//                         width: "100%",
//                         border: "2px solid black",
//                         padding: "10px",
//                         marginBottom: "12px",
//                         boxSizing: "border-box",
//                         display: "flex",
//                         flexDirection: "row",
//                         alignItems: "flex-start",
//                         gap: "10px",
//                     }}
//                 >
//                     {/* Left Content */}
//                     <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
//                         <div style={{ fontSize: "16px", fontWeight: "bold" }}>
//                             Code: {item.labelData?.barcodeNumber}
//                         </div>
//                         <div style={{ fontSize: "18px", fontWeight: "bold" }}>
//                             MRP: ₹{item.labelData?.sellingPrice}
//                         </div>
//                         <div style={{ fontSize: "14px" }}>
//                             {item.labelData?.purchaseYearMonth}
//                         </div>
//                     </div>

//                     {/* QR Code Right Side */}
//                     <img
//                         src={item.labelData?.qrCode}
//                         style={{
//                             width: "90px",
//                             height: "90px",
//                             objectFit: "contain",
//                             marginLeft: "auto",
//                         }}
//                     />
//                 </div>
//             ))}
//         </div>
//     );
// });

// export default LabelPrint58;

import { forwardRef } from "react";

const LabelPrint58 = forwardRef(({ items = [] }, ref) => {
    const labels = items.flatMap(item => [item, item]); // auto-duplicate

    return (
        <div
            ref={ref}
            style={{
                width: "100mm",
                display: "flex",
                flexWrap: "wrap",
                fontFamily: "Arial",
            }}
        >
            {labels.length === 0 && (
                <div style={{ padding: 20, textAlign: "center", fontSize: 14 }}>
                    No Label Data Found
                </div>
            )}

            {labels.map((item, index) => (
                <div
                    key={index}
                    style={{
                        width: "48mm",
                        height: "25mm",
                        border: "1px solid black",
                        padding: "2mm",
                        paddingTop: "6mm",
                        boxSizing: "border-box",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",

                        /* 🔥 IMPORTANT FOR PRINT */
                        marginBottom: "3mm",   // ✅ Row gap
                        marginRight: "2mm",    // ✅ Column gap
                        pageBreakInside: "avoid"
                    }}
                >
                    {/* LEFT CONTENT */}
                    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                        <div style={{ fontSize: "12px", fontWeight: "bold" }}>
                            {item.labelData?.barcodeNumber}
                        </div>
                        <div style={{ fontSize: "12px", fontWeight: "bold" }}>
                            MRP: ₹{item.labelData?.sellingPrice}
                        </div>
                        <div style={{ fontSize: "10px" }}>
                            {item.labelData?.purchaseYearMonth}
                        </div>
                    </div>

                    {/* QR CODE */}
                    <img
                        src={item.labelData?.qrCode}
                        alt="QR"
                        style={{
                            width: "15mm",
                            height: "15mm",
                            objectFit: "contain",
                        }}
                    />
                </div>
            ))}
        </div>
    );
});


export default LabelPrint58;